module.exports = __webpack_public_path__ + "img/windows_xp.98729627.svg";